<template>
<v-container fluid>
    
  <v-card :style="{'border-radius':'5px','border':'1px solid'+$store.getters.getColorPalette().panelBorderColorCode}" flat  :dark="$store.getters.getColorPalette().isDark" >
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$store.getters.getTextMap().search"
        single-line
        hide-details
        :dark="$store.getters.getColorPalette().isDark" 
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="actions"
      item-key="action_id"
      :search="search"
      :single-expand="true"
      show-expand
      :expanded.sync="expanded"
      :loading="loading"
      :dark="$store.getters.getColorPalette().isDark" 
    loading-text="Loading... Please wait"
    >
    <template v-slot:top>
      <v-toolbar
        flat
        
      >
        <v-toolbar-title>{{$store.getters.getTextMap().actions}}</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <CreateActionBottomSheet v-if="$store.state.user && $store.state.settingMode && $store.getters.getAccessByLevels(['engineeraccess']) " />
      </v-toolbar>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <Action :action="item" />
       
      </td>
    </template>
          
    </v-data-table>
  </v-card>
</v-container>
</template>

<script>
import CreateActionBottomSheet from '@/components/modals/CreateActionBottomSheet'
import Action from '@/components/items/Action'

export default {
    name:'ActionTable',
    components:{
        CreateActionBottomSheet,
        Action
    },
    data(){
        return {
            search:'',
            loading:false,
            expanded: [],
            headers: [
          {
            text: 'ID',
            align: 'start',
            filterable: false,
            value: 'action_id',
            class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName
            
          },
          { text: 'Name', value: 'name', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
          { text: 'Type', value: 'type', class: " text-capitalize font-weight-black "+this.$store.getters.getColorPalette().tableHeaderColorName },
          
          
        ],
        }
    },
    computed:{
        actions(){
            //console.log(this.$store.getters.getNodesByWorkspaceId(this.workspace.workspace_id))
            return this.$store.getters.getActions()
        },
        
    },
}
</script>
<style scoped>
.v-card__title{
  background-color:#bdbdbd00;
}
.theme--light.v-toolbar.v-sheet{
  background-color: #B2DFDB00;
}
.theme--light.v-data-table{
   background-color: #B2DFDB00;
}
</style>